(function () {
	'use strict';

	angular
		.module('wizard-english-test.services')
		.service('UnitService', UnitService)

	/** @ngInject */
	function UnitService(HttpService) {
		const UnitService = {
			getUnitStates,
			getUnitCities,
			getUnits
		};

		return UnitService;

		function getUnitStates() {
			return HttpService.get('/units/states');
		}

		function getUnitCities(stateId) {
			return HttpService.get('/units/states/' + stateId + '/cities');
		}

		function getUnits(cityId) {
			return HttpService.get('/units/cities/' + cityId);
		}
	}
}());